<template>
  <div v-if="eventData">
    <intelbras-event-data
      v-if="eventData.device.type === 'alarm_bridge_intelbras'"
      :event-data="eventData"
    />
    <dmp-event-data
      v-if="eventData.device.type === 'alarm_bridge_dmp'"
      :event-data="eventData"
    />
  </div>
</template>

<script>
import axios from "@/libs/axios";
import IntelbrasEventData from "./IntelbrasEventData.vue";
import DmpEventData from "./DmpEventData.vue";

export default {
  name: "alarm-bridge-event-data",
  components: {DmpEventData, IntelbrasEventData},
  props: {
    data: Object,
  },
  data() {
    return {
      eventData: null,
    }
  },
  mounted() {

    const facilityId = this.data.unit.id;
    const alarmId = this.data.id;

    axios.get(`v1/services/alarm-panel/by-facility-and-alarm?facility_id=${facilityId}&alarm_id=${alarmId}`)
      .then(({data}) => {
        this.eventData = data.data;
        if (this.eventData) {
          this.$emit('has-alarm-bridge-data', true);
        } else {
          this.$emit('has-alarm-bridge-data', false);
        }
        // device -> panel info.
        // alarm -> alarm info.
      })
      .catch((error) => {
        this.$emit('has-alarm-bridge-data', false);
      });
  },
}
</script>


<style scoped lang="scss">

</style>
